import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/core/services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'src/app/core/interfaces/user';
import { Utils } from 'src/app/core/resources/utils';
import { NgxSpinnerService } from 'ngx-spinner';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { CompaniesService } from '../list-companies.service';
import { AbstractControl, AsyncValidatorFn, FormBuilder, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ReactiveForm } from 'src/app/core/resources/reactive-form';
import { Company, Model } from 'src/app/core/interfaces/company';
import { AccountService } from 'src/app/modules/account/account.service';
import { Permission } from 'src/app/core/resources/permission';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { MatTabGroup } from '@angular/material/tabs';
import { Observable, of, Subscription } from 'rxjs';
import { catchError, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { AdminUsersService } from '../../admin-users/admin-users.service';
import { environment } from 'src/environments/environment';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { ShippingCost } from 'src/app/core/enums/shipping-cost.enum';
import { AmountsCargoEnum } from 'src/app/core/enums/amountsCargo.enum';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { BasicCompany } from 'src/app/core/interfaces/basicCompany';
import { DateManager } from 'src/app/core/managers/date.manager';
import { InsurancePolicyService } from 'src/app/core/services/insurance-policy.service';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { IntegrationEnum } from 'src/app/core/enums/integration.enum';
import { CompanyManager } from 'src/app/core/managers/company.manager';
import { SelectCompanyService } from 'src/app/modules/guides/state-guide/state-guide.service';
import { SaasTransportCompany } from 'src/app/core/interfaces/saasTransportCompany';

@Component({
  selector: 'app-form-company',
  templateUrl: './form-company.component.html',
  styleUrls: ['./form-company.component.scss'],
  providers: [AuthService, Model]
})
export class DetailCompanyComponent extends ReactiveForm implements OnInit {

  public environment = environment;
  permission = Permission;
  companyUser: Company;
  company: Company;
  isCreation: boolean = false;
  listCommercial: Observable<User[]>
  formControlCommercial: FormControl = new FormControl();
  optionsCity = {
    title: 'Ciudad'
  }
  cityControl: FormControl = new FormControl('', Validators.required);
  citySub: Subscription;
  addressControl: FormControl = new FormControl('', Validators.required);
  addressSub: Subscription;
  formValidate = '';
  roles = [
    { alias: 'Generadora de carga', id: '1', name: 'CARGO_GENERATOR' },
    { alias: 'Empresa de transporte', id: '2', name: 'TRANSPORT_COMPANY' },
  ];
  formControlRole = new FormControl('', Validators.required);
  formControlExpirationDate = new FormControl('', Validators.required);
  fromNowFilter = (date: Date | null): boolean => {
    const currentControlDate = this.formControlExpirationDate.value;
    if (currentControlDate && currentControlDate.getTime() === date.getTime()) return true;
    return DateManager.isSameOrBefore(new Date(), date);
  };
  minUtility = ShippingCost.MINIMUN_UTILITY;
  minUtilityAdittionalService = ShippingCost.MINIMUN_UTILITY_ADDITIONAL_COST;
  maxAdvancePercentage = AmountsCargoEnum.MAX_ADVANCE_PERCENTAGE_ALLOWED_ALL_COMPANIES;
  minAdvancePercentage = 0;
  listCompanies: BasicCompany[] = [];
  allCompanies: Array<{ companyId: string, name: string }> = [];
  listTabs = [{ name: 'Información general', clicked: false }, { name: 'Configuración administrativa', clicked: false }, { name: 'Requisitos de cumplido', clicked: false }, { name: 'Correos', clicked: false }, { name: 'Centros de Costo', clicked: false }, { name: 'Recursos', clicked: false }, { name: 'Métricas e históricos', clicked: false }, { name: 'Etiquetas', clicked: false }, { name: 'Configuración de guías', clicked: false }];
  activeTab: string = 'Información general';
  @ViewChild(MatTabGroup, { static: true }) tabGroup: MatTabGroup;
  @ViewChild('infoToMinistryAndPolicies') infoToMinistryAndPolicies: ElementRef;
  /** true cuando la transportadora asignada aplica la póliza del contratante. */
  clientPolicyRequired: boolean = false;
  hasSelectedTransportCompany: boolean = false;
  transportCompanySub: Subscription;
  redirection: boolean = false;
  optionsDocumentUser: OptionsAutocomplete = {
    title: 'N° de identificación del comercial',
    filterBy: 'userClient'
  }
  changeCommercialUser: boolean = false;
  changeCommercialControl: FormControl = new FormControl();
  selectedTabIndex: number = 0;
  listenerId: string = '';
  companyChangesSub: Subscription;
  isSaasTransportCompany: boolean = false;
  private saasTransportCompanyIds: string[] = null;
  saasTransportCompanies: SaasTransportCompany[] = [];
  constructor(
    private authService: AuthService,
    private companiesService: CompaniesService,
    public utils: Utils,
    private spinner: NgxSpinnerService,
    private snackBarService: SnackBarService,
    private router: Router,
    private route: ActivatedRoute,
    public formBuilder: FormBuilder,
    private accountService: AccountService,
    public modelCompany: Model,
    private permissionRole: PermissionRole,
    public adminUsersService: AdminUsersService,
    public cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private companyManager: CompanyManager,
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private selectCompanyService: SelectCompanyService,
    private insurancePolicyService: InsurancePolicyService
  ) {
    super(
      formBuilder,
      modelCompany.model,
      modelCompany.model
    );
  }

  ngOnInit() {
    if (history && history.state && history.state.redirection) this.redirection = history.state.redirection;
    this.companyUser = this.authService && this.authService.getCompany();
    this.listCompanies = this.accountService.listRegisterCompanies();
    this.minUtilityAdittionalService = this.authService && this.authService.getCompanySaaS().utilityAdditionalService && !this.permissionRole.hasPermission(
      this.permission.administration.module,
      this.permission.administration.updateCompanyUtilitiesUnrestricted
    ) ? this.authService.getCompanySaaS().utilityAdditionalService
      : this.companyUser.companyId === environment.rootNit ? ShippingCost.MINIMUN_UTILITY_ADDITIONAL_COST_TECLOGI : ShippingCost.MINIMUN_UTILITY_ADDITIONAL_COST;
    this.minUtility = this.authService.getCompanySaaS().utility && !this.permissionRole.hasPermission(
      this.permission.administration.module,
      this.permission.administration.updateCompanyUtilitiesUnrestricted
    ) ? this.authService.getCompanySaaS().utility : ShippingCost.MINIMUN_UTILITY;
    this.form.addControl('externalId', new FormControl(false, Validators.required));
    // Solo una SaaS con servicios de transporte asigna empresa de transporte a
    // sus clientes. En el otro régimen el control no existe, así que no se pide
    // ni viaja al backend.
    if (this.hasTransportServicesCompany) {
      // transportCompany es un objeto, pero debe mantenerse como un control único
      // para que mat-select pueda escribir el valor seleccionado.
      this.form.addControl('transportCompany', new FormControl(null, Validators.required));
    }
    this.form.removeControl('rndcCredentials');
    this.setValidatorsForm(this.modelCompany.companyValidators, this.form);
    this.form.get('utility').setValidators([Validators.required, Validators.max(100), this.checkMinimunUtility('utility', this.minUtility)]);
    if (this.hasPermissionAdditionalCosts)
      this.form.get('utilityAdditionalService').setValidators([Validators.required, Validators.max(100), this.checkMinimunUtility('utilityAdditionalService', this.minUtilityAdittionalService)]);
    this.setSubscriptions();
    this.setPolicyInformationState();

    if (window.location.hash.split('/').filter((aa) => aa === 'detail').length) {
      const params = this.route.snapshot.params;
      if (!this.utils.objIsEmpty(params) && this.utils.isDefined(params.id))
        this.initializeCompany(params.id);
      else this.goToList();
    } else if (window.location.hash.split('/').filter((aa) => aa === 'create').length) {
      this.authService && this.authService.getUserSession() && this.authService.getUserSession().information && this.authService.getUserSession().information.name && this.formControlCommercial.setValue(this.authService.getUserSession().information.name)
      this.isCreation = true;
      this.loadSaasTransportCompanies();
      this.setCompanyIdAsyncValidator();
      this.setValidations();
      this.setCommercial();
    } else {
      this.goToList();
    }
    this.formControlCommercial.disable();
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
    if (this.redirection) {
      setTimeout(() => {
        this.infoToMinistryAndPolicies.nativeElement.scrollIntoView({ behavior: 'smooth' });
        this.infoToMinistryAndPolicies.nativeElement.addEventListener('animationend', () => {
          this.renderer.removeClass(this.infoToMinistryAndPolicies.nativeElement, 'border-transient');
        });
      }, 300);
      this.renderer.addClass(this.infoToMinistryAndPolicies.nativeElement, 'border-transient');
    }
    if (history && history.state && history.state.tab) {
      setTimeout(() => {
        this.goToTab(history.state.tab);
      }, 500);
    }
  }

  private setSubscriptions() {
    this.citySub = this.cityControl.valueChanges
      .subscribe(value => this.form.get('municipalityCode').setValue(value && value.id ? value.id : ''));
    this.addressSub = this.addressControl.valueChanges
      .subscribe(value => this.form.get('address').setValue(value && value.address ? value.address : null));
    const transportCompanyControl = this.form.get('transportCompany');
    if (transportCompanyControl) {
      this.transportCompanySub = transportCompanyControl.valueChanges
        .pipe(
          map((value: any): string => {
            this.hasSelectedTransportCompany = !!(value && value.id);
            return value && value.id ? value.id : null;
          }),
          distinctUntilChanged<string>(),
          switchMap((transportCompanyId: string) => transportCompanyId
            ? this.insurancePolicyService.clientPolicyRequired(transportCompanyId).pipe(catchError(() => of(false)))
            : of(false))
        )
        .subscribe(required => this.updateClientPolicyRequirement(required));
    }
  }

  /** Actualiza la disponibilidad de la póliza según la transportadora elegida. */
  private updateClientPolicyRequirement(required: boolean): void {
    this.clientPolicyRequired = required;
    this.setDynamicValidations();
    this.setPolicyInformationState();
  }

  /**
   * La póliza individual sólo puede editarse si la transportadora la permite.
   * Sin transportadoras no hay nada que deshabilitar: ahí la bandera de la
   * empresa SaaS decide qué campos son obligatorios, no cuáles se pueden tocar.
   */
  private setPolicyInformationState(): void {
    const insuranceInformation = this.form && this.form.get('insuranceInformation');
    if (!this.hasTransportServicesCompany || this.clientPolicyRequired) {
      if (insuranceInformation) insuranceInformation.enable({ emitEvent: false });
      this.formControlExpirationDate.enable({ emitEvent: false });
      return;
    }
    if (insuranceInformation) insuranceInformation.disable({ emitEvent: false });
    this.formControlExpirationDate.disable({ emitEvent: false });
  }

  private initializeCompany(id: string) {
    this.disabledFieldsForm({
      companyId: '',
    }, this.form);
    if (this.utils.isDefined(this.companiesService.compnySelected) && !this.redirection) {
      this.setCompany(this.companiesService.compnySelected);
      this.initCompanyWatch(this.companiesService.compnySelected.companyId);
    } else if (this.utils.isDefined(id)) {
      this.getCompany(id, false);
      this.initCompanyWatch(id);
    } else {
      this.goToList();
    }
  }

  private initCompanyWatch(companyId: string) {
    if (!companyId) return;
    this.listenerId = '';
    const { id, eventEmitter } = this.companiesService.watch(companyId);
    this.listenerId = id;
    this.companyChangesSub = eventEmitter.subscribe((company: Company) => {
      if (!company || (company && this.company && company.companyId !== this.company.companyId)) return;
      this.setCompany(company);
    }, console.error);
  }

  private setCompany(company: Company) {
    this.company = company;
    this.setSaasTransportCompanyState(company && company.companyId);
    this.setValidations();
    this.setOptions();
    this.setCommercial();
    this.isCreation = false;
    this.company && this.company.businessPartner && this.company.businessPartner.name && this.formControlCommercial.setValue(this.company.businessPartner.name);
    this.updateForm(this.company);
    if (this.company && this.company.role && this.company.role.name)
      this.formControlRole.setValue(this.roles.filter(role => role.name === this.company.role.name)[0]);
    if (this.company && this.company.insuranceInformation && this.company.insuranceInformation.expirationDate)
      // El valor puede venir en DD/MM/YYYY (contratante) o YYYY-MM-DD (transportadora SaaS);
      // InsurancePolicyService detecta el formato por forma antes de parsear.
      this.formControlExpirationDate.setValue(this.insurancePolicyService.parseExpirationDate(this.company.insuranceInformation.expirationDate));
  }

  private setSaasTransportCompanyState(companyId: string): void {
    this.isSaasTransportCompany = false;
    if (!companyId) return;

    if (this.saasTransportCompanyIds) {
      this.isSaasTransportCompany = this.saasTransportCompanyIds.includes(companyId);
      return;
    }

    this.companiesService.getCachedSaasTransportCompanies().subscribe(
      (companies: SaasTransportCompany[]) => {
        this.setSaasTransportCompanies(companies);
        if (this.company && this.company.companyId === companyId) {
          this.isSaasTransportCompany = this.saasTransportCompanyIds.includes(companyId);
        }
      },
      () => {
        if (this.company && this.company.companyId === companyId) this.isSaasTransportCompany = false;
      }
    );
  }

  private loadSaasTransportCompanies(): void {
    this.companiesService.getCachedSaasTransportCompanies().subscribe(
      (companies: SaasTransportCompany[]) => this.setSaasTransportCompanies(companies),
      () => this.setSaasTransportCompanies([])
    );
  }

  private setSaasTransportCompanies(companies: SaasTransportCompany[]): void {
    this.saasTransportCompanies = companies || [];
    this.saasTransportCompanyIds = this.saasTransportCompanies.map(company => company.companyId);
  }

  getCompany(id?: string, updateCompanies = true) {
    this.accountService.validateEntity(2, id ? id : this.company.companyId).subscribe(
      (success: Company) => {
        if (success && success.companyId) {
          this.setCompany(success);
          if (updateCompanies && this.authService) this.authService.getAllCompanies().toPromise().finally();
        } else {
          this.company = null;
          this.goToList();
        }
      },
      (error) => {
        this.company = null;
        this.goToList();
      }
    );
  }

  private checkMinimunUtility(type: 'utility' | 'utilityAdditionalService', minUtility: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value === 0 || control.value >= minUtility)
        return null;
      if (this.company && this.authService && this.company.companyId === this.authService.getCompanySaaS().companyId)
        return null;
      if (type === 'utility' && this.company && this.company.utility && this.company.utility === control.value)
        return null;
      if (type === 'utilityAdditionalService' && this.company && this.company.utilityAdditionalService && this.company.utilityAdditionalService === control.value)
        return null;
      return { minimunUtility: true };
    };
  }

  private setCompanyIdAsyncValidator() {
    const companyIdControl = this.form.get('companyId');
    companyIdControl.setAsyncValidators(this.nitAlreadyExistsValidator());
    companyIdControl.updateValueAndValidity();
  }

  private nitAlreadyExistsValidator(): AsyncValidatorFn {
    return async (control: AbstractControl): Promise<ValidationErrors | null> => {
      if (!this.isCreation || !control) return null;
      const nit = `${control.value ? control.value : ''}`.replace(/\D/g, '');
      if (nit.length !== 9) return null;
      if (!this.allCompanies.length) this.allCompanies = await this.loadCompaniesToValidateNit();
      const companyWithSameNit = this.allCompanies.find(company => {
        const companyId = `${company && company.companyId ? company.companyId : ''}`.replace(/\D/g, '');
        return companyId.length >= 9 && companyId.substring(0, 9) === nit;
      });
      return companyWithSameNit ? {
        companyIdAlreadyExists: {
          companyName: companyWithSameNit.name ? companyWithSameNit.name : '',
          companyId: companyWithSameNit.companyId ? companyWithSameNit.companyId : ''
        }
      } : null;
    };
  }

  private async loadCompaniesToValidateNit(): Promise<Array<{ companyId: string, name: string }>> {
    if (this.authService && this.authService.getCompanies() && this.authService.getCompanies().length)
      return this.authService.getCompanies().map(company => ({ companyId: company.companyId, name: company.name }));
    try {
      const companies = await this.selectCompanyService.getAllCompanies().toPromise()
      return companies && companies.length ? companies.map(company => ({ companyId: company.companyId, name: company.name })) : [];
    } catch (error) {
      return [];
    }
  }

  setCommercial() {
    this.changeCommercialControl.valueChanges.subscribe(value => {
      if (value && value.information && value.information.document && value !== this.formControlCommercial.value) {
        this.formControlCommercial.setValue(value.information.name);
        this.changeCommercialUser = false;
      }
    });
  }

  public onSelectCommercial($event: MatAutocompleteSelectedEvent) {
    if ($event.option.value) {
      this.form.get('businessPartner').setValue($event.option.value);
    }
  }

  public getName(data: any): string {
    return data ? data.name : data;
  }

  public compareTransportCompanies(first: any, second: SaasTransportCompany): boolean {
    if (!first || !second) return first === second;
    return first.id === second.companyId || first.companyId === second.companyId;
  }

  setValidations() {
    const fields = ['colorConfiguration.primaryColor', 'colorConfiguration.secondaryColor'];
    fields.forEach(field => {
      this.isPrincipalCompany ? this.form.get(field).setValidators(Validators.required) : this.form.get(field).disable();
    })
    if (this.hasTransportServicesCompany) this.form.get('role.name').setValidators(Validators.required);
    this.setDynamicValidations();
  }

  setDynamicValidations(changePolicyOption = false) {
    this.isExpirationDateRequired(changePolicyOption)
      ? this.formControlExpirationDate.setValidators(Validators.required)
      : this.formControlExpirationDate.clearValidators();
    const optionalFields = ['insuranceInformation.policyNumber', 'insuranceInformation.companyName', 'insuranceInformation.companyId', 'insuranceInformation.expirationDate'];
    optionalFields.forEach(field => {
      const validators = [Validators.required]
      this.getConditionsToBeRequiredPolicy(changePolicyOption)
        ? this.form.get(field).setValidators(validators)
        : this.form.get(field).clearValidators();
      if (field === 'insuranceInformation.companyId') {
        const existingValidator = this.form.get(field).validator;
        const newValidator = Validators.maxLength(10);
        const combinedValidators = existingValidator
          ? [existingValidator, newValidator]
          : [newValidator];
        this.form.get(field).setValidators(combinedValidators);
      }
      this.form.get(field).updateValueAndValidity();
    })
    this.formControlExpirationDate.updateValueAndValidity();
  }

  /**
   * Con transportadoras manda la bandera de la que quedó asignada. Sin ellas se
   * conserva el criterio previo: la empresa principal registra su póliza única
   * salvo que delegue en cada cliente, y el cliente solo cuando se le delegó.
   */
  getConditionsToBeRequiredPolicy(changePolicyOption = false): boolean {
    if (this.hasTransportServicesCompany) { return this.clientPolicyRequired; }
    return !!(this.applyPolicyByCompany && !this.isPrincipalCompany)
      || (!changePolicyOption && this.isPrincipalCompany);
  }

  /**
   * changePolicyOption llega desde el radio de la empresa principal: al marcar
   * "póliza individual por cliente" sus propios datos dejan de ser obligatorios
   * antes de guardar.
   */
  private isExpirationDateRequired(changePolicyOption: boolean): boolean {
    if (this.hasTransportServicesCompany) { return this.clientPolicyRequired; }
    return this.applyPolicyByCompany || changePolicyOption;
  }

  /** Bandera del régimen sin transportadoras: vive en la empresa SaaS. */
  get applyPolicyByCompany(): boolean {
    return this.insurancePolicyService.appliesClientPolicyLegacy();
  }

  policyChange(event: MatRadioChange) {
    if (event && this.utils.isDefined(event.value)) { this.setDynamicValidations(event.value); }
  }

  setOptions() {
    this.optionsCity['initialMunicipalityCode'] = this.company && this.company.municipalityCode ? this.company.municipalityCode : '';
    this.optionsCity = { ...this.optionsCity };
  }

  changeCommercial(change: boolean) {
    this.changeCommercialUser = change;
  }

  onSubmit() {
    if (!this.dataDialog || !this.dataDialog.newThirdParty) {
      this.saveDataCompany();
    }
  }

  saveDataCompany() {
    if (this.isCreation) this.createCompany();
    else this.updateCompany();
  }

  createCompany() {
    if (this.verifyFields()) {
      const company: Company = this.form.value;
      company.exclusive = (company.exclusive);
      company.emailSubject = '¡Su pedido va en camino!';
      company.emailBody = '¡Vamos en camino a entregar tu producto!';
      company.configuration = {
        reports: [
          {
            type: 'addressDuration',
            units: 'milliseconds',
            title: 'Duración en cada dirección'
          },
          {
            type: 'routeDuration',
            units: 'milliseconds',
            title: 'Duración total de cada servicio'
          }
        ],
        serviceType: 'express'
      };
      company.businessPartner = {
        documentTypeId: `${this.authService.getUserSession().information.documentTypeId}`,
        documentTypeName: `${this.authService.getUserSession().information.documentTypeName}`,
        document: `${this.authService.getUserSession().information.document}`,
        name: `${this.authService.getUserSession().information.name}`
      }
      this.spinner.show();
      this.companiesService.createCompany(
        company
      ).subscribe(
        (success: Company) => {
          if (success && !success.message && success.companyId) {
            this.createRoles(success);
            this.authService.getAllCompanies().toPromise().finally();
          } else if (success && success.message) {
            this.spinner.hide();
            this.snackBarService.openSnackBar(success.message, undefined, 'error');
          } else {
            this.spinner.hide();
            this.snackBarService.openSnackBar('Ocurrió un error al crear la compañía', undefined, 'error');
          }
        },
        (error) => {
          this.spinner.hide();
          this.snackBarService.openSnackBar('Ocurrió un error al crear la compañía', undefined, 'error');
        }
      );
    }
  }

  createRoles(company: Company) {
    const rolesCompanies = this.companiesService.getModelRole(company.companyId);
    this.companiesService.createMultipleRole(rolesCompanies).subscribe(
      (success) => {
        this.finishCreateCompany();
        this.snackBarService.openSnackBar("La empresa y sus roles se crearon correctamente", undefined, "success");
      },
      (error) => {
        this.finishCreateCompany();
        this.snackBarService.openSnackBar("Hubo un error al crear los roles de la empresa", undefined, "error");
      }
    );
  }

  finishCreateCompany() {
    this.spinner.hide();
    this.goToList();
  }

  getDetailCompanyParent() {
    this.authService.getDetailCompany(this.companyUser.companyId).subscribe(
      (success) => {
        if (this.isCreation) this.goToList();
      },
      (error) => {
        if (this.isCreation) this.goToList();
      }
    );
  }

  updateCompany() {
    if (this.verifyFields()) {
      const newCompany: Company = { ...this.company, ...this.form.value };
      if (this.isSaasRelatedCompany) {
        delete newCompany.policyByCompany;
        delete newCompany.rndcCredentials;
      }
      // Con transportadoras la bandera vive en cada empresa de transporte y el
      // formulario no la expone: enviarla sobrescribiría el valor guardado con
      // el default del modelo.
      if (this.hasTransportServicesCompany) { delete newCompany.policyByCompany; }
      delete newCompany.emails;
      if (this.changeCommercialControl && this.changeCommercialControl.value)
        newCompany.businessPartner = this.changeCommercialControl.value.information;
      if (newCompany && newCompany.accountingConfig && this.allPropertiesAreEmpty(newCompany.accountingConfig)) delete newCompany.accountingConfig;
      this.spinner.show();
      this.companiesService.updateCompany(
        newCompany
      ).subscribe(
        async (success) => {
          this.snackBarService.openSnackBar('Información actualizada correctamente');
          this.getCompany(this.company.companyId);
          if (this.authService && (this.company.companyId === this.authService.getCompany().companyId)) {
            try { await this.authService.getFullUserByEmail(this.authService.getUserSession().email).toPromise(); } catch (error) { }
          }
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
          this.snackBarService.openSnackBar('Ocurrió un error al actualizar la compañía', undefined, 'error');
        }
      );
    }
  }

  async setCompanyState(state: boolean) {
    let description = 'Active';
    if (!state) {
      const response = await this.companyManager.openDialogConfirmWithDescription(`Escriba la razón por la cual desea desactivar esta empresa`, "Motivo");
      if (!response.confirm) return;
      description = response.description;
    } else {
      const response = await this.companyManager.openDialogConfirm(`¿Estás seguro que deseas activar esta empresa?`);
      if (!response.confirm) return;
    }
    this.spinner.show();
    let success = false;
    try {
      const response = await this.companiesService.setCompanyState(this.company.companyId, state, description).toPromise();
      success = !!(response && response.message);
    } catch (error) { } finally {
      this.spinner.hide();
    }
    if (success) this.snackBarService.openSnackBar('Estado de la empresa actualizado correctamente');
    else this.snackBarService.openSnackBar('Ocurrió un error al actualizar el estado de la empresa', undefined, 'error');
    this.getCompany();
  }


  allPropertiesAreEmpty(obj: Object) {
    return Object.values(obj).every(value => {
      if (value === null || value === undefined) return true;
      if (typeof value === 'string' && value.trim() === '') return true;
      if (Array.isArray(value) && value.length === 0) return true;
      if (typeof value === 'object' && Object.keys(value).length === 0) return true;
      return false;
    });
  }

  onSelectTab($event) {
    const selectedIndex = $event;
    const selectedTabLabel = this.tabGroup && this.tabGroup._tabs && this.tabGroup._tabs.toArray()[selectedIndex] && this.tabGroup._tabs.toArray()[selectedIndex].textLabel ? this.tabGroup._tabs.toArray()[selectedIndex].textLabel : '';
    const tab = this.listTabs.find(tab => tab.name === selectedTabLabel);
    if (tab) {
      this.activeTab = tab.name;
      tab.clicked = true;
    }
  }

  goToList() {
    this.router.navigate(['administration/companies/list']);
  }

  onSelectCity($event) {
    if ($event.data && $event.data.id) {
      this.form.get('municipalityCode').setValue($event.data.id);
    }
  }

  onSelectRole($event) {
    this.form.get('role.id').setValue($event.value.id);
    this.form.get('role.name').setValue($event.value.name);
  }

  onChangeDatePicker($event) {
    this.form.get('insuranceInformation.expirationDate').setValue(DateManager.dateToString($event.value, 'DD/MM/YYYY'));
  }

  clickedTab(event: string) {
    if (event) this.listTabs.find(tab => tab.name === event).clicked = true;
  }

  isClickedTab(event: string): boolean {
    const tab = this.listTabs.find(tab => tab.name === event);
    return tab ? tab.clicked : false;
  }

  goToTab(label: string) {
    const tabIndex = this.tabGroup._tabs.toArray().findIndex(tab => tab.textLabel.trim() === label);
    if (tabIndex !== -1) {
      this.selectedTabIndex = tabIndex;
      this.activeTab = label;
    }
  }

  verifyFields(): boolean {
    this.formValidate = 'touched';
    if (this.utils.errorMessagesCustomized(this.form.get('companyId'), 'NIT', 9, 9, null, null, { companyIdAlreadyExists: "Ya existe una empresa registrada con este NIT" })) return false;
    else if (this.utils.errorMessagesCustomized(this.form.get('name'), 'razón social', 3)) return false;
    else if (this.utils.errorMessagesCustomized(this.form.get('email'), 'correo electrónico', null, 100)) return false;
    else if (this.utils.errorMessagesCustomized(this.form.get('municipalityCode'), 'ciudad')) return false;
    else if (this.utils.errorMessagesCustomized(this.form.get('address'), 'dirección')) return false;
    else if (this.utils.errorMessagesCustomized(this.form.get('phone'), 'teléfono')) return false;
    else if (this.utils.errorMessagesCustomized(this.form.get('insuranceInformation.companyId'), 'nit de la entidad emisora', null, 10)) return false;
    else if (this.utils.errorMessagesCustomized(this.form.get('insuranceInformation.companyName'), 'nombre de la entidad emisora')) return false;
    else if (this.utils.errorMessagesCustomized(this.form.get('insuranceInformation.policyNumber'), 'no. de poliza')) return false;
    else if (this.utils.errorMessagesCustomized(this.form.get('insuranceInformation.expirationDate'), 'fecha de expiración')) return false;
    else if (this.utils.errorMessagesCustomized(this.form.get('role.name'), 'rol')) return false;
    else if (this.utils.errorMessagesCustomized(this.form.get('transportCompany'), 'empresa de transporte')) return false;
    else if (this.utils.errorMessagesCustomized(this.form.get('contact.name'), 'nombres para facturación', 3)) return false;
    else if (this.utils.errorMessagesCustomized(this.form.get('contact.lastName'), 'apellidos para facturación', 3)) return false;
    else if (this.utils.errorMessagesCustomized(this.form.get('contact.email'), 'correo para facturación', null, 100)) return false;
    // else if (this.utils.errorMessagesCustomized(this.getPrefix(0).get('name'), 'prefijo de manifiestos')) return false;
    // else if (this.utils.errorMessagesCustomized(this.getPrefix(1).get('name'), 'prefijo de remesas')) return false;
    // else if (this.utils.errorMessagesCustomized(this.getPrefix(2).get('name'), 'prefijo de servicios nacionales')) return false;
    // else if (this.utils.errorMessagesCustomized(this.getPrefix(3).get('name'), 'prefijo de servicios urbanos')) return false;
    else if (this.form.get('utility').hasError('minimunUtility')) {
      this.snackBarService.openSnackBar(`La utilidad no puede ser menor al ${this.minUtility}%`, undefined, 'alert');
      return false;
    }

    else if (this.utils.errorMessagesCustomized(this.form.get('utility'), 'utilidad', null, null, this.minUtility, 100)) return false;
    else if (this.form.get('utilityAdditionalService').hasError('minimunUtility')) {
      this.snackBarService.openSnackBar(`La utilidad de servicios adicionales no puede ser menor al ${this.minUtilityAdittionalService}%`, undefined, 'alert');
      return false;
    }
    else if (this.utils.errorMessagesCustomized(this.form.get('utilityAdditionalService'), 'utilidad de servicios adicionales', null, null, this.minUtilityAdittionalService, 100)) return false;
    else if (this.utils.errorMessagesCustomized(this.form.get('advancePercentage'), 'porcentaje de anticipo', null, null, this.minAdvancePercentage, this.maxAdvancePercentage)) return false;
    else if (this.utils.errorMessagesCustomized(this.form.get('colorConfiguration.primaryColor'), 'color principal')) return false;
    else if (this.utils.errorMessagesCustomized(this.form.get('colorConfiguration.secondaryColor'), 'color secundario')) return false;
    else if (this.form.invalid) {
      this.snackBarService.openSnackBar(FormMessages.GENERAL_ERROR_DEFAULT);
      return false
    } else return true;
  }

  get isActiveCompany(): boolean {
    return !!this.company && (!this.company.state || (!!this.company.state && this.company.state.active));
  }

  get hasPermissionToAddEmails(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.administration.module,
      this.permission.administration.createEmailCompany
    ) && !!this.company;
  }

  get hasPermissionAdditionalCosts(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.additionalCosts
    )
  }

  get hasTransportServicesCompany(): boolean {
    return this.authService && this.authService.hasTransportServicesCompany;
  }

  // getPrefix(index) {
  //   return this.form.get('rndcPrefix').controls[index] as FormControl;
  // }

  get isPrincipalCompany(): boolean {
    return !!(this.listCompanies.length && this.company && this.company.companyId &&
      this.listCompanies.some(company => company.nit === this.company.companyId) && this.authService &&
      this.authService.getCompany() && this.authService.getCompany().companyId === this.company.companyId);
  }

  get isSaasCompany(): boolean {
    const saasCompany = this.authService && this.authService.getCompanySaaS();
    return !!(this.company && this.company.companyId && saasCompany && this.company.companyId === saasCompany.companyId);
  }

  get isSaasRelatedCompany(): boolean {
    return this.isSaasCompany || this.isSaasTransportCompany;
  }

  get createUpdatePermission(): boolean {
    return !!((this.permissionRole.hasPermission(this.permission.administration.module, this.permission.administration.updateCompany) && window.location.hash.split('/').filter((aa) => aa === 'detail').length) || (this.permissionRole.hasPermission(this.permission.administration.module, this.permission.administration.createCompany) && window.location.hash.split('/').filter((aa) => aa === 'create').length));
  }

  get policyExpirated(): boolean {
    const expirationDateControl = this.form && this.form.get('insuranceInformation.expirationDate');
    const expirationDate = expirationDateControl && expirationDateControl.value;
    // Se delega en InsurancePolicyService para que el formato (DD/MM/YYYY o
    // YYYY-MM-DD) se detecte en un único lugar de la app.
    return !!expirationDate && this.insurancePolicyService.isExpired({ expirationDate });
  }

  get hasSiigoIntegration(): boolean {
    return this.authService && this.authService.getCompanySaaS().integrationCredentials &&
      this.authService.getCompanySaaS().integrationCredentials.length &&
      this.authService.getCompanySaaS().integrationCredentials.some(integration => integration && integration.integrationChannel && integration.integrationChannel.toLowerCase() === IntegrationEnum.SIIGO.toLowerCase() && integration.state);
  }

  get hasPermissionToCostCenter(): boolean {
    return (this.permissionRole.hasPermission(
      this.permission.payments.module,
      this.permission.payments.createCostCenter
    ) || this.permissionRole.hasPermission(
      this.permission.payments.module,
      this.permission.payments.associateCostCenter
    ))
  }

  get hasPermissionToGuideNovelties(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.guide.module,
      this.permission.guide.editGuideNovelties
    )
  }

  get hasPermissionToActivateOrDeactivateCompany(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.administration.module,
      this.permission.administration.activateOrDeactivateCompany
    )
  }

  ngOnDestroy() {
    this.cdRef.detach();
    if (this.citySub) this.citySub.unsubscribe();
    if (this.addressSub) this.addressSub.unsubscribe();
    if (this.companyChangesSub) this.companyChangesSub.unsubscribe();
    if (this.transportCompanySub) this.transportCompanySub.unsubscribe();
    this.companiesService.stopWatch(this.listenerId);
  }
}
